// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartBardcodesStyles } from "@eisinc/App/Components/Cart/CartBarcodes";
import { ellipsis } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

cartBardcodesStyles.wrapper = {
    css: css`
        @page {
            margin-top: 88px;
        }

        @page :first {
            margin-top: 82px;
        }

        display: grid;
        grid-template-columns: repeat(2, 320px);
        grid-auto-rows: 190px;
        gap: 36px 50px;
        ${({ isSafariDesktopBrowser, isFirefoxBrowser }: any) => css`
            ${isSafariDesktopBrowser &&
            css`
                grid-template-columns: repeat(2, 284px);
                grid-auto-rows: 185px;
                gap: 18px 42px;

                @page {
                    margin-top: 106px;
                }
                @page :first {
                    margin-top: 106px;
                }
            `}

            ${isFirefoxBrowser &&
            css`
                gap: 36px 38px;
                @page {
                    margin-bottom: 96px;
                    margin-top: 54px;
                }
                @page :first {
                    margin-top: 78px;
                }
            `}
        `}
    `,
};

cartBardcodesStyles.barcodeWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        padding: 10px;
        height: 100%;
        width: 100%;
        overflow: hidden;
        break-inside: avoid-page;
        -webkit-break-inside: avoid;
        page-break-inside: avoid;
    `,
};

cartBardcodesStyles.description = {
    css: css`
        display: block;
        width: 90%;
        line-height: 10px;
        margin-bottom: 5px;
        text-align: center;
        ${ellipsis(2)};
    `,
};

cartBardcodesStyles.lineInfoWrapper = {
    css: css`
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        width: 90%;

        > div {
            line-height: 12px;
        }
    `,
};

cartBardcodesStyles.lineCardFooter = {
    css: css`
        text-align: right;
        width: 90%;
        display: inline-flex;
        justify-content: flex-end;
        align-items: center;
    `,
};

cartBardcodesStyles.printLogo = {
    size: 100,
};

cartBardcodesStyles.logoWrapper = {
    css: css`
        display: inline-block;
        margin-right: 25px;
    `,
};

cartBardcodesStyles.codeWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,
};
